import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Trad } from '../../interfaces/trad.interface';

@Injectable()
export class MinaTradarService {
  constructor(
    protected http: HttpClient,
    @Inject('API_URL') protected apiUrl: string) {
  }

  public getMinaTradar(instance: string): Observable<Trad[]> {
    return this.http.get<Trad[]>(`${this.apiUrl}${instance}/tradar/get`);
  }
}
